import { Content } from "./Content";
import "./Content.scss";

export default Content;
